<template>
  <article>
    <v-card v-for="(trigger, idx) of triggers" :key="idx">
      <v-container>
        <v-subheader>Error Budget Burn %</v-subheader>
        <v-layout row wrap>
          <v-flex xs12 pa-2>
            <v-slider
              v-model="trigger.burnPct"
              min="1"
              max="100"
            >
              <template v-slot:prepend>
                <v-text-field
                  v-model="trigger.burnPct"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  min="1"
                  max="100"
                  style="width: 60px"
                ></v-text-field>
              </template>
            </v-slider>
          </v-flex>
        </v-layout>
        <v-subheader>Within Time Window</v-subheader>
        <v-layout row wrap>
          <v-flex xs12 pa-2>
            <v-slider
              v-model="trigger.burnWindowDays"
              label="Days"
              min="0"
              :max="90"
              required
            >
              <template v-slot:prepend>
                <v-text-field
                  v-model="trigger.burnWindowDays"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  min="0"
                  max="90"
                  style="width: 60px"
                ></v-text-field>
              </template>
            </v-slider>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12 pa-2>
            <v-slider
              v-model="trigger.burnWindowHours"
              label="Hours"
              min="0"
              :max="23"
              required
            >
              <template v-slot:prepend>
                <v-text-field
                  v-model="trigger.burnWindowHours"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  min="0"
                  max="23"
                  style="width: 60px"
                ></v-text-field>
              </template>
            </v-slider>
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>
    </v-card>
  </article>
</template>

<script>
export default {
  name: "NewBurnRateTriggers",
  props: {
    triggers: {
      type: Array,
      required: true
    }
  }
};
</script>
